import { StarSettingsIcon } from './StarSettingsIcon';

/**
 * author: Colton Wiscombe
 * id 30D8C8F6-3BDE-40B8-A015-6E607C370360
 * name star-settings
 * version: 5.7.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/star-settings.svg
 * tags
 * - Settings 
 */
export const FavoriteSettingsIcon = StarSettingsIcon;
export default FavoriteSettingsIcon